import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import oIconLibrary from 'utils/iconLibrary';

const ConstituentSearchResultsList = ({
  aSearchResults,
  fnResetSearch,
  fnHandleChosenConstituent,
}) => {
  if (!aSearchResults) {
    return null;
  }

  if (aSearchResults.length === 0) {
    return (
      <p className='constituentSearchResultsList__noResults'>
        No results found.
      </p>
    );
  }

  return (
    <ol className='constituentSearchResultsList'>
      {aSearchResults.map((oResult) => (
        <li
          className='constituentSearchResultsList__item'
          key={oResult.LOOKUPID}
          data-cy={`constituent-search-result-${oResult.LOOKUPID}`}
        >
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <button
            type='button'
            className='constituentSearchResultsList__button'
            onClick={() => {
              const { NICKNAME, FIRST_NAME, LAST_NAME } = oResult;
              const sFullName = `${NICKNAME || FIRST_NAME || ''} ${
                LAST_NAME || ''
              }`;
              fnHandleChosenConstituent({
                FIRST_NAME: NICKNAME || FIRST_NAME || '',
                LAST_NAME: LAST_NAME || '',
                NAME: sFullName,
                EMAIL_ADDRESS: oResult.EMAIL_ADDRESS || '',
                LOOKUPID: oResult.LOOKUPID || '',
              });
              fnResetSearch();
            }}
          >
            <FontAwesomeIcon
              icon={oIconLibrary.fontAwesome.user}
              className='constituentSearchResultsList__icon'
            />
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: oResult.HIGHLIGHT,
              }}
            />
          </button>
        </li>
      ))}
    </ol>
  );
};

ConstituentSearchResultsList.propTypes = {
  aSearchResults: PropTypes.arrayOf(PropTypes.object),
  fnResetSearch: PropTypes.func.isRequired,
  fnHandleChosenConstituent: PropTypes.func.isRequired,
};

ConstituentSearchResultsList.defaultProps = {
  aSearchResults: [],
};

export default ConstituentSearchResultsList;
